import { cn } from "@/lib/utils";
import { statusTone, statusLabel } from "@/lib/format";

const TONE_CLASSES = {
    success: "bg-success/12 text-success border-success/25",
    warning: "bg-warning/14 text-warning border-warning/30",
    destructive: "bg-destructive/12 text-destructive border-destructive/25",
    accent: "bg-accent/12 text-accent border-accent/25",
    muted: "bg-muted text-muted-foreground border-border",
    primary: "bg-primary/12 text-primary border-primary/25",
};

export const StatusBadge = ({ status, tone, label, className, dot = true }) => {
    const t = tone || statusTone(status);
    const text = label || statusLabel(status);
    return (
        <span
            className={cn(
                "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap",
                TONE_CLASSES[t] || TONE_CLASSES.muted,
                className,
            )}
        >
            {dot && (
                <span
                    className={cn(
                        "h-1.5 w-1.5 rounded-full",
                        t === "success" && "bg-success",
                        t === "warning" && "bg-warning",
                        t === "destructive" && "bg-destructive",
                        t === "accent" && "bg-accent",
                        t === "primary" && "bg-primary",
                        t === "muted" && "bg-muted-foreground",
                    )}
                />
            )}
            {text}
        </span>
    );
};
